import React, { useState, useEffect } from 'react';
import { List, ListItemButton, ListItemText } from '@mui/material';
import ListSubheader from '@mui/material/ListSubheader';
import { useTranslation } from "react-i18next";
import secureLocalStorage from 'react-secure-storage';
import { agmsClientRequestGet } from '../../../apis/request';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { formatServerTime } from "../../../utils/serverTime";

export default function ClickableList({userDeviceList, setUserDeviceDate, loading}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [myList, setMyList] = useState([]);

  //초기 placeholder([{}])나 깨진 항목이 'undefined 일'로 그려지지 않게 유효한 행만
  const validList = (userDeviceList || []).filter((it) => it && it.started_dt);

  const handleListItemClick = (index, item) => {
    setUserDeviceDate(item.started_dt);
    setSelectedIndex(index);
  };

  useEffect(async () => {
    if(secureLocalStorage.getItem('role') === '1001'){
        let response = await agmsClientRequestGet(`/api/user/all`);
        setMyList(response);
    }
   


  },[]);
  const { t:translate, i18n } = useTranslation(); 
  return (
    <>
        <div style={{
            fontSize:'18px',
        }}>
            {
                secureLocalStorage.getItem('role') === '1001' ? 
                "사용자 목록"
                :
                translate("measurement_list")
            }
        </div>
    
        <div style={{
            height: secureLocalStorage.getItem('role') === '1001' ? '650px' : '400px',
            overflow:'auto',
        }}>
            <List style={{
            }}>

                {
                    secureLocalStorage.getItem('role') === '1001' ? 
                    <ListSubheader style={{
                        display:'flex',
                        flexDirection:'row',
                        borderTop:'2px solid #8A8A8A',
                        borderBottom:'1px solid #ccc'
                    }}>
                        <div style={{flex:1}}>
                            이름
                        </div>
                        <div style={{flex:1}}>
                            이메일
                        </div>
                    </ListSubheader>
                    :
                    <ListSubheader style={{
                        display:'flex',
                        flexDirection:'row',
                        borderTop:'2px solid #8A8A8A',
                        borderBottom:'1px solid #ccc' 
                    }}>
                        <div style={{flex:1}}>
                            {translate("serial_number")}
                        </div>
                        <div style={{flex:1}}>
                            {translate("measurement_period")}
                        </div>
                        <div style={{flex:1}}>
                            {translate("start_date")}
                        </div>
                        <div style={{flex:1}}>
                            {translate("end_date")}
                        </div>
                    </ListSubheader>

                }
                
                {
                    secureLocalStorage.getItem('role') === '1001' ? 
                    <>
                        {
                            myList.map((item, index) => (
                                <ListItemButton
                                    key={index}
                                    selected={selectedIndex === index}
                                    onClick={() => handleListItemClick(index, item)}
                                    style={{
                                        display:'flex',
                                        flexDirection:'row',
                                        borderBottom:'1px solid #ccc' 
                                    }}
                                >
                                    <ListItemText primary={item.name} style={{ flex:1, textAlign:'center'}}/>
                                    <ListItemText primary={item.email} style={{flex:1, textAlign:'center'}}/>
                                   
                                </ListItemButton>
                            ))
                        }
                    </>
                    :
                    <>
                        {
                            loading ?
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center', padding:'50px 0'}}>
                                <CircularProgress size={30}/>
                            </div>
                            :
                            validList.length === 0 ?
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center', padding:'50px 0', color:'#888'}}>
                                측정 이력이 없습니다.
                            </div>
                            :
                            validList.map((item, index) => (
                                <ListItemButton
                                    key={index}
                                    selected={selectedIndex === index}
                                    onClick={() => handleListItemClick(index, item)}
                                    style={{
                                        display:'flex',
                                        flexDirection:'row',
                                        borderBottom:'1px solid #ccc'
                                    }}
                                >
                                    <ListItemText primary={item.serial_number} style={{ flex:1, textAlign:'center'}}/>
                                    <ListItemText primary={item.duration + ' ' +translate('day')} style={{flex:1, textAlign:'center'}}/>
                                    <ListItemText primary={formatServerTime(item.started_dt, 'YYYY-MM-DD HH:mm:ss', item.started_dt)} style={{flex:1, textAlign:'center'}}/>
                                    <ListItemText primary={item.last_dt === null || item.last_dt === '' ? '---': formatServerTime(item.last_dt, 'YYYY-MM-DD HH:mm:ss', item.last_dt)} style={{flex:1,textAlign:'center'}}/>
                                    {/* <ListItemText primary={'기기 시리얼 넘버 : ' + item.serial_number + ",    측정 기간 : " + item.started_dt + " ~ " + item.last_dt} /> */}
                                </ListItemButton>
                            ))
                        }
                    </>
                }
              
                
            </List>
        
        </div>
        {/* <hr style={{
            height:'3px',
            backgroundColor:'black'
        }}/> */}
    </>
    
    
  );
}